import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-xl font-bold text-black-900 flex items-center" }
const _hoisted_2 = { class: "choice-express-fee-content" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "text-black" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "mb_5"
}
const _hoisted_8 = ["colspan", "width"]
const _hoisted_9 = { class: "tips" }

import { t } from '@/plugins/i18n'
import { ref, onMounted, computed } from 'vue'
import { getShipFeeConfig } from '@/apis/user'
// 弹窗

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = ref(false)
const checkTransportation = ref('0')
const configList: any = ref([])
onMounted(() => {
  getShipFeeConfig({ brandFlag: 0 }).then((res) => {
    configList.value = res.data
  })
})
const shipments = ref([
  {
    label: '船舶輸送',
    value: '0',
    icon: 'https://static-s.theckb.com/BusinessMarket/SEO/choice/Boat.png'
  },
  {
    label: '航空輸送',
    value: '1',
    icon: 'https://static-s.theckb.com/BusinessMarket/SEO/choice/airplane.png'
  }
])

const shipConfig = computed(() => {
  return configList.value[checkTransportation.value]
})

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: "cursor-pt",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true)),
        style: {"color":"#0586FE","font-weight":"700"}
      }, _toDisplayString(_unref(t)('物流收费规则')) + ">", 1)
    ]),
    _createVNode(_component_el_dialog, {
      "append-to-body": true,
      modelValue: show.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      top: "25vh",
      center: "",
      draggable: true,
      "show-close": false,
      "custom-class": "choice-express-fee-dialog",
      width: 720
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('料金ルール')), 1),
          _createVNode(_component_el_alert, {
            type: "warning",
            "show-icon": ""
          }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('订单低于15万日元，只能选择空运，订单高于15万日元，可选择空运或者海运。')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shipments.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["choice-express-tab", { 'active': checkTransportation.value == item.value }]),
                onClick: ($event: any) => (checkTransportation.value = item.value),
                key: index
              }, _toDisplayString(item.label), 11, _hoisted_6))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shipConfig).configList, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.priceDataList?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.categoryNameJp) + " : ", 1))
                : _createCommentVNode("", true),
              (item.priceDataList?.length)
                ? (_openBlock(), _createElementBlock("table", {
                    class: "table table-fixed w-full border-collapse border border-gray-300 text-center rounded-[4px] mb_10",
                    key: index
                  }, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.priceDataList, (priceData, k) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: k,
                          class: "border border-gray-300",
                          colspan: priceData.cost !== null ? 1 : priceData.ladderPrices?.length,
                          width: priceData.width
                        }, _toDisplayString(priceData.adaptTypeNameJp), 9, _hoisted_8))
                      }), 128))
                    ]),
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.priceDataList, (priceData, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (priceData.cost !== null)
                            ? (_openBlock(), _createElementBlock("td", {
                                class: "border border-gray-300",
                                key: k
                              }, _toDisplayString(_unref(t)('{x}件以上（包含{x}件）', { x: 1 })), 1))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(priceData.ladderPrices, (ladder, k) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  class: "border border-gray-300",
                                  key: k
                                }, _toDisplayString(ladder.endNum === 999999 ? _unref(t)('{x}件以上（包含{x}件）', { x: ladder.startNum }) : _unref(t)('{x}-{y}点', {
        x:
          ladder.startNum, y: ladder.endNum
      })), 1))
                              }), 128))
                        ], 64))
                      }), 256))
                    ]),
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.priceDataList, (priceData, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (priceData.cost !== null)
                            ? (_openBlock(), _createElementBlock("td", {
                                class: "border border-gray-300",
                                key: k
                              }, _toDisplayString(_unref(t)('{x}元/件', { x: priceData.cost })), 1))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(priceData.ladderPrices, (ladder, k) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  class: "border border-gray-300",
                                  key: k
                                }, _toDisplayString(_unref(t)('{x}元/件', { x: ladder.price })), 1))
                              }), 128))
                        ], 64))
                      }), 256))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('*品牌商品可享更低物流价格')), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})